/**
 * Hand a fetched file to the browser — saved under its original name, or opened
 * in a new tab where the browser can show it (DOC-81 §2). The server has already
 * recorded the act; these only deliver the bytes.
 */
export function saveBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function openBlob(blob: Blob): void {
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener');
  // Revoked later, not now: the new tab is still reading it.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
